// extracted by mini-css-extract-plugin
export default {"switcher_container":"index_switcher_container__ZrDAx","switcher_container_small":"index_switcher_container_small__Wnw-p"};